import { render } from "./Adfs.vue?vue&type=template&id=5e57d498&scoped=true"
import script from "./Adfs.vue?vue&type=script&lang=js"
export * from "./Adfs.vue?vue&type=script&lang=js"

import "./Adfs.vue?vue&type=style&index=0&id=5e57d498&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e57d498"]])

export default __exports__